$(function(){
  $('body').on('click', '.radio-tab', function () {
    $(this).tab('show');
  });
});
